/* ====================================================================
   Oduree - Cart Drawer (brandbook 2026)
   ====================================================================
   Open/close logic, AJAX add-to-cart interceptor, qty/remove acties,
   section-refresh via Shopify Section Rendering API.

   Events die de drawer luistert:
     - cart:open     open drawer
     - cart:refresh  herlaad inhoud + update badge
     - cart:update   alias van cart:refresh

   Exposes:  window.CartDrawer  (global helper)
   ==================================================================== */
(function () {
  "use strict";

  if (window.CartDrawer && window.CartDrawer._initialized) return;

  var SECTION_ID = "cart-drawer";
  var CART_T = window.ODUREE_CART_TRANSLATIONS || (window.ODUREE_T && window.ODUREE_T.cartDrawer) || {};
  var BASE_FREE_SHIPPING_THRESHOLD_CENTS = 4500;

  function getPresentmentRate() {
    var currency = window.Shopify && window.Shopify.currency;
    if (!currency || currency.active === "EUR") return 1;
    var rate = parseFloat(currency.rate);
    return isFinite(rate) && rate > 0 ? rate : 1;
  }

  function toPresentmentCents(baseCurrencyCents) {
    return Math.round((parseInt(baseCurrencyCents, 10) || 0) * getPresentmentRate());
  }

  // --------------------------------------------------------------------
  // Runtime cache van /products/{milestone.productHandle}.js voor
  // milestones met een product-thumbnail. Map per
  // handle -> featured_image URL. Voorkomt hardcoded CDN-paths die
  // breken als de admin de afbeelding her-uploadt.
  var _giftImageCache = {};

  // --------------------------------------------------------------------
  // MILESTONES configuratie (reward-bar + cadeautje-paneel)
  // --------------------------------------------------------------------
  // Gift tiers komen uit section blocks in de theme customizer. De fallback
  // blijft alleen gratis verzending tonen als er nog geen gift blocks staan.
  var GIFT_TIERS = [];
  // Handles die tijdelijk niet als drempelcadeau mogen meedoen (leeg = alles aan).
  var PAUSED_GIFT_HANDLES = [];
  // Bundel-gift (PDP bundel-kiezer tier 2): gratis sleutelhanger bij EXACT
  // 2 parfumproducten in de cart. We voegen de ÉCHTE sleutelhanger-variant
  // (€19,95) toe; de Shopify automatic discount "Gratis sleutelhanger bij
  // 2 parfums" (BXGY 100%) rekent hem op €0 af. De variant-ID komt uit de
  // cart-drawer sectie-settings via het data-bundle-gift-variant-id
  // attribuut (leeg = feature uit).
  // LET OP: Shopify past max 1 automatische product-discount per order toe
  // (zie docs/discounts-conflict-overzicht.md). Daarom verwijderen we de
  // sleutelhanger direct zodra het aantal parfums ≠ 2 is — zo kan deze BXGY
  // nooit tegelijk met de "3+1 gratis geur"-BXGY nodig zijn.
  var BUNDLE_GIFT_KEY = "parfum-duo-keychain";
  var BUNDLE_GIFT_LEGACY_KEY = "aph-3-1-keychain";
  var BUNDLE_GIFT_HANDLE = "alcantara-sleutelhanger";
  var BUNDLE_GIFT_QTY_TRIGGER = 2;
  var BUNDLE_DUO_PROPERTY_VALUE = "duo";
  var FALLBACK_MILESTONES = [
    {
      key: "m2",
      threshold: toPresentmentCents(BASE_FREE_SHIPPING_THRESHOLD_CENTS),
      label: CART_T.freeShippingLabel || "Free shipping",
      desc: CART_T.freeShippingDesc || "Reach this amount for free shipping.",
      nextRewardLabel: CART_T.freeShippingNext || "free shipping",
      type: "shipping",
    },
  ];
  var MILESTONES = FALLBACK_MILESTONES.slice();

  // Plaatshouders betekenen hetzelfde als in Shopify's money-filter:
  // {{amount}} = 1,134.65 en {{amount_with_comma_separator}} = 1.134,65.
  // Zo staan bedragen uit dit script in de stijl van de markt, net als de
  // Liquid-bedragen ernaast (£16.00 op oduree.com, €17,95 op oduree.nl).
  function formatWithShopifyMoneyFormat(cents, format) {
    var n = Math.round(Number(cents) || 0);
    var opmaak = function (decimalen, duizend, decimaal) {
      var delen = (n / 100).toFixed(decimalen).split(".");
      var heel = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
      return delen[1] ? heel + decimaal + delen[1] : heel;
    };
    var replacements = {
      amount: opmaak(2, ",", "."),
      amount_no_decimals: opmaak(0, ",", "."),
      amount_with_comma_separator: opmaak(2, ".", ","),
      amount_no_decimals_with_comma_separator: opmaak(0, ".", ","),
      amount_with_apostrophe_separator: opmaak(2, "'", "."),
      amount_no_decimals_with_space_separator: opmaak(0, " ", ","),
      amount_with_space_separator: opmaak(2, " ", ","),
      amount_with_period_and_space_separator: opmaak(2, " ", "."),
    };
    return String(format || "{{amount}}").replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return replacements[key] != null ? replacements[key] : replacements.amount;
    });
  }

  // Shopify geeft prijzen als integer cents. Gebruik de actieve shop/currency format
  // zodat EUR/SEK in cart drawer hetzelfde blijft als op de rest van de site.
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "";
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var format = settings.currencyCodeEnabled
      ? settings.moneyWithCurrencyFormat
      : settings.moneyFormat;
    return formatWithShopifyMoneyFormat(cents, format);
  }

  function interpolate(template, values) {
    var out = template || "";
    Object.keys(values || {}).forEach(function (key) {
      out = out.replace(new RegExp("\\[" + key + "\\]", "g"), values[key]);
    });
    return out;
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function getLineProperty(item, name) {
    var props = (item && item.properties) || {};
    if (!props) return "";
    if (Object.prototype.hasOwnProperty.call(props, name)) return props[name];
    return "";
  }

  // Verzekerde Verzending is een serviceregel, geen aankoop: telt niet mee voor de cadeaudrempels
  // (net als in de functie drempel-cadeau).
  var VERZEKERING_PRODUCT_ID = 8880468361562;
  function isVerzekering(item) { return !!item && Number(item.product_id) === VERZEKERING_PRODUCT_ID; }
  // Kortingen op de hele wagen (kortingscodes op de bestelling); regelkortingen zitten al in final_line_price.
  function wagenKorting(cart) {
    var som = 0;
    ((cart && cart.cart_level_discount_applications) || []).forEach(function (d) { som += d.total_allocated_amount || 0; });
    return som;
  }

  // Winkelmand lezen via de gedeelde lezer uit layout/theme.liquid (één verzoek voor alle scripts,
  // na elke wijziging vers). Zonder die lezer (andere layout) gewoon zelf ophalen.
  function leesCart() {
    if (window.OdureeCart && typeof window.OdureeCart.get === "function") return window.OdureeCart.get();
    return fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function isCartGiftLine(item) {
    return String(getLineProperty(item, "_oduree_gift") || "").toLowerCase() === "true";
  }

  function getCartItemHandle(item) {
    var handle = String((item && (item.handle || item.product_handle)) || "").toLowerCase();
    if (handle) return handle;

    var url = String((item && item.url) || "").toLowerCase();
    var match = url.match(/\/products\/([^/?#]+)/);
    return match && match[1] ? match[1] : "";
  }

  function isGiftTierLine(item) {
    var tierKey = String(getLineProperty(item, "_oduree_gift_tier") || "");
    return isCartGiftLine(item) && tierKey && tierKey !== BUNDLE_GIFT_KEY && tierKey !== BUNDLE_GIFT_LEGACY_KEY;
  }

  function isBundleGiftLine(item) {
    if (!isCartGiftLine(item)) return false;

    var tierKey = String(getLineProperty(item, "_oduree_gift_tier") || "");
    var handle = getCartItemHandle(item);
    var title = String(((item && item.product_title) || (item && item.title) || "")).toLowerCase();

    return (
      tierKey === BUNDLE_GIFT_KEY ||
      tierKey === BUNDLE_GIFT_LEGACY_KEY ||
      handle === BUNDLE_GIFT_HANDLE ||
      title.indexOf("sleutelhanger") !== -1 ||
      title.indexOf("keychain") !== -1
    );
  }

  // Duo-bundel-regel = via de PDP bundel-kiezer "2 stuks" toegevoegd
  // (line property _oduree_bundle: 'duo'). ALLEEN deze regels triggeren de
  // gratis sleutelhanger — 2 losse parfums in de cart dus niet.
  function isBundleDuoLine(item) {
    if (isCartGiftLine(item)) return false;
    return String(getLineProperty(item, "_oduree_bundle") || "") === BUNDLE_DUO_PROPERTY_VALUE;
  }

  function copyValue(value, fallback) {
    if (!value || /translation missing/i.test(String(value))) return fallback;
    return value;
  }

  var CartDrawer = {
    _initialized: false,
    drawer: null,
    overlay: null,
    body: null,
    footer: null,

    init: function () {
      this.drawer = document.getElementById("cart-drawer");
      this.overlay = document.getElementById("cart-overlay");
      if (!this.drawer || !this.overlay) return;

      this.body = this.drawer.querySelector("[data-cart-body]");
      this._loadGiftTierSettings();
      this._applyCadeautjePanelOverride(0);

      // Custom element wrapper: voeg open()/close() toe aan <cart-drawer>
      // zodat legacy scripts blijven werken.
      if (this.drawer.open === undefined) {
        this.drawer.open = this.open.bind(this);
        this.drawer.close = this.close.bind(this);
        this.drawer.refresh = this.refresh.bind(this);
      }

      this._bindEvents();
      this._bindThemeEditorEvents();
      this._overrideTabLabels();
      this._overrideRewardAndGifts();
      this._enrichUpsellCompareAtPrices();
      this._initialized = true;

      // Pre-fetch product images voor gift tiers met een productHandle.
      this._loadGiftImages();

      // Bij page-load direct gift tiers syncen, ook als de klant terugkomt
      // met een bestaande cart of een native Shopify add-to-cart flow.
      var self2 = this;
      setTimeout(function () {
        self2._syncGiftAndMaybeRefresh();
      }, 800);
    },

    _bindEvents: function () {
      var self = this;

      // Overlay klik = close
      this.overlay.addEventListener("click", function () {
        self.close();
      });

      // ESC = close
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && self.isOpen()) self.close();
      });

      // Event-delegation voor [data-cart-close], [data-cart-qty], [data-cart-remove],
      // [data-upsell-add] en discount-form. Delegatie in document zodat re-render
      // (innerHTML swap) geen event-listeners verliest.
      document.addEventListener("click", function (e) {
        var el;

        // Sluit
        if ((el = e.target.closest("[data-cart-close]"))) {
          e.preventDefault();
          self.close();
          return;
        }

        // Qty +/-
        // Muteren op de regel-key (data-key) als die er is: scripts die
        // regels toevoegen (cadeaus, kraskaart-sleutelhanger) verschuiven de
        // regelindex, en dan zou een klik op index de verkeerde regel raken.
        if ((el = e.target.closest("[data-cart-qty]"))) {
          e.preventDefault();
          var line = parseInt(el.getAttribute("data-line"), 10);
          var item = el.closest("[data-cart-item]");
          var currentQty =
            parseInt(item && item.getAttribute("data-qty"), 10) || 1;
          var delta = el.getAttribute("data-cart-qty") === "+" ? 1 : -1;
          var newQty = Math.max(0, currentQty + delta);
          // Direct tonen (aantal, regelprijs, totaal), daarna gebundeld naar
          // Shopify: snel klikken = één verzoek, geen wachten per klik.
          if (item) self._optimisticQty(item, currentQty, newQty);
          self._queueChange(item && item.getAttribute("data-key"), line, newQty);
          return;
        }

        // Verwijder
        if ((el = e.target.closest("[data-cart-remove]"))) {
          e.preventDefault();
          var removeLine = parseInt(el.getAttribute("data-cart-remove"), 10);
          var removeItem = el.closest("[data-cart-item]");
          if (removeItem) self._optimisticQty(removeItem, parseInt(removeItem.getAttribute("data-qty"), 10) || 1, 0);
          self._queueChange(removeItem && removeItem.getAttribute("data-key"), removeLine, 0);
          return;
        }

        // Abonnement volledig verwijderen — boxregels zijn individueel
        // vergrendeld (vaste samenstelling), dus dit is de enige uitgang.
        // De cadeau-sync ruimt de welkomstcadeaus daarna vanzelf op.
        if ((el = e.target.closest("[data-cart-remove-subscription]"))) {
          e.preventDefault();
          el.disabled = true;
          leesCart()
            .then(function (cart) {
              var keys = ((cart && cart.items) || [])
                .filter(function (it) { return it.selling_plan_allocation; })
                .map(function (it) { return it.key; });
              var chain = Promise.resolve();
              keys.forEach(function (key) {
                chain = chain.then(function () {
                  return fetch("/cart/change.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify({ id: key, quantity: 0 }),
                  });
                });
              });
              return chain;
            })
            .then(function () {
              if (!el.closest("#cart-drawer")) { window.location.reload(); return; }
              return self.refresh();
            })
            .catch(function () { el.disabled = false; });
          return;
        }
        // Upsell toevoegen
        if ((el = e.target.closest("[data-upsell-add]"))) {
          e.preventDefault();
          var variantId = el.getAttribute("data-variant-id");
          var original = el.textContent;
          el.textContent = "...";
          el.disabled = true;
          self
            ._addToCart(variantId, 1)
            .then(function () {
              el.textContent = CART_T.addedSuccess || "Added";
              setTimeout(function () {
                el.textContent = original;
                el.disabled = false;
              }, 1200);
            })
            .catch(function () {
              el.textContent = CART_T.genericError || "Error";
              setTimeout(function () {
                el.textContent = original;
                el.disabled = false;
              }, 1200);
            });
          return;
        }
      });

      // Tab switching (header tabs: Winkelwagen / Cadeautje)
      // Schakelt zichtbaarheid tussen cart-body en cart-gift-panel. Actieve
      // tab krijgt .is-active (gouden onderstreping via CSS). Body wordt
      // via inline style display:none gezet omdat het via CSS alleen
      // overridden wordt (scope blijft zo scherp).
      document.addEventListener("click", function (e) {
        var tab = e.target.closest("[data-cart-tab]");
        if (!tab) return;
        var which = tab.getAttribute("data-cart-tab");
        var drawer = tab.closest("[data-cart-drawer]");
        if (!drawer) return;
        drawer.querySelectorAll("[data-cart-tab]").forEach(function (t) {
          t.classList.toggle("is-active", t === tab);
        });
        var body = drawer.querySelector("[data-cart-body]");
        var panel = drawer.querySelector("#cart-gift-panel");
        if (which === "gifts") {
          if (body) body.style.display = "none";
          if (panel) {
            panel.classList.add("is-active");
            panel.setAttribute("aria-hidden", "false");
          }
        } else {
          if (body) body.style.display = "";
          if (panel) {
            panel.classList.remove("is-active");
            panel.setAttribute("aria-hidden", "true");
          }
        }
      });

      // Kortingscode verwijderen - klik op het kruisje in de applied-chip.
      // Stuurt lege discount-string naar /cart/update.js wat alle codes wist.
      document.addEventListener("click", function (e) {
        var rm = e.target.closest("[data-discount-remove]");
        if (!rm) return;
        e.preventDefault();
        rm.disabled = true;
        var chip = rm.closest("[data-discount-applied]");
        if (chip) chip.classList.add("is-removing");
        // Alleen déze code weghalen: de overige codes (bijv. een tweede
        // kraskaartcode) komma-gescheiden terugsturen. /cart/update.js heeft
        // replace-semantiek, een lege string zou alles wissen.
        var weg = String((chip && chip.getAttribute("data-discount-code")) || "").toUpperCase();
        leesCart()
          .then(function (cart) {
            var rest = ((cart && cart.discount_codes) || [])
              .map(function (c) { return String((c && c.code) || ""); })
              .filter(function (c) { return c && c.toUpperCase() !== weg; });
            return fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ discount: rest.join(",") }),
            });
          })
          .then(function () {
            return CartDrawer.refresh();
          })
          .catch(function (err) {
            console.error("[CartDrawer] discount remove error", err);
            rm.disabled = false;
            if (chip) chip.classList.remove("is-removing");
          });
      });

      // Kortingscode submit - past discount AJAX toe, blijft in drawer.
      // Via /cart/update.js { discount: "CODE" } ondersteund sinds Shopify 2022.
      // Replace-semantiek: lege string wist alle codes, komma-separated list
      // vervangt alle bestaande codes met de nieuwe set.
      document.addEventListener("submit", function (e) {
        var form = e.target.closest("[data-cart-coupon]");
        if (!form) return;
        e.preventDefault();

        var input = form.querySelector('[name="discount"]');
        var btn = form.querySelector('button[type="submit"]');
        var code = ((input && input.value) || "").trim();
        if (!code) return;

        var originalLabel = btn ? btn.textContent : (CART_T.couponApply || "Apply");
        if (btn) {
          btn.disabled = true;
          btn.textContent = CART_T.couponApplying || "Applying...";
        }
        form.classList.remove("is-error", "is-success");

        // Bestaande codes behouden (replace-semantiek van /cart/update.js):
        // een tweede kraskaartcode mag de eerste niet stil overschrijven.
        leesCart()
          .then(function (cart) {
            var bestaand = ((cart && cart.discount_codes) || [])
              .map(function (c) { return String((c && c.code) || ""); })
              .filter(function (c) { return c && c.toUpperCase() !== code.toUpperCase(); });
            return fetch("/cart/update.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify({ discount: bestaand.concat([code]).join(",") }),
            });
          })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            // Kraskaartcode (SLEUTELHANGER): Shopify meldt die pas "applicable"
            // zodra de sleutelhanger in de cart ligt, en die wordt juist door
            // het kraskaart-script toegevoegd. Dus: code staat op de cart maar
            // is nog niet applicable -> eerst het script laten syncen, daarna
            // de cart opnieuw lezen en pas dan oordelen.
            var codes0 = (cart && cart.discount_codes) || [];
            var present = codes0.some(function (c) {
              return c && c.code && c.code.toLowerCase() === code.toLowerCase();
            });
            var applicable0 = codes0.some(function (c) {
              return c && c.code && c.code.toLowerCase() === code.toLowerCase() && c.applicable;
            });
            if (present && !applicable0 && window.OdureeKraskaart && typeof window.OdureeKraskaart.sync === "function") {
              return window.OdureeKraskaart.sync()
                .then(function () {
                  return leesCart();
                })
                .catch(function () { return cart; });
            }
            return cart;
          })
          .then(function (cart) {
            // Check of Shopify de code als "applicable" markeert
            var codes = (cart && cart.discount_codes) || [];
            var applied = codes.some(function (c) {
              return (
                c &&
                c.code &&
                c.code.toLowerCase() === code.toLowerCase() &&
                c.applicable
              );
            });

            if (applied) {
              form.classList.add("is-success");
              if (input) input.value = "";
              return CartDrawer.refresh().then(function () {
                // Re-locate knop na refresh (innerHTML swap)
                var newBtn = document.querySelector(
                  "[data-cart-coupon] button[type=submit]"
                );
                if (newBtn) {
                  newBtn.textContent = CART_T.couponApplied || "Applied";
                  setTimeout(function () {
                    newBtn.textContent = originalLabel;
                    newBtn.disabled = false;
                  }, 1800);
                }
              });
            }

            // Code ongeldig of niet toepasbaar
            form.classList.add("is-error");
            if (btn) {
              btn.textContent = CART_T.couponInvalid || "Invalid code";
              var herstel = function () {
                btn.textContent = originalLabel;
                btn.disabled = false;
                form.classList.remove("is-error");
              };
              var herstelTimer = setTimeout(herstel, 2200);
              // Referral-beloning (VRIEND-…): precieze reden ophalen bij de worker
              // ("al gebruikt" / "verlopen") in plaats van een kaal "ongeldig".
              var refCfg = window.ODUREE_REFERRAL || {};
              if (/^VRIEND-/i.test(code) && refCfg.worker && window.fetch) {
                fetch(refCfg.worker + "/referral/code?code=" + encodeURIComponent(code))
                  .then(function (r) { return r.json(); })
                  .then(function (j) {
                    var label = j && j.status === "gebruikt" ? CART_T.couponUsed : j && j.status === "verlopen" ? CART_T.couponExpired : null;
                    if (!label) return;
                    clearTimeout(herstelTimer);
                    btn.textContent = label;
                    setTimeout(herstel, 3200);
                  })
                  .catch(function () {});
              }
            }
          })
          .catch(function (err) {
            console.error("[CartDrawer] discount apply error", err);
            form.classList.add("is-error");
            if (btn) {
              btn.textContent = CART_T.couponError || "Error";
              setTimeout(function () {
                btn.textContent = originalLabel;
                btn.disabled = false;
                form.classList.remove("is-error");
              }, 2200);
            }
          });
      });

      // Custom events vanuit andere secties
      document.addEventListener("cart:open", function () {
        self.open();
      });
      document.addEventListener("cart:refresh", function () {
        self.refresh();
      });
      document.addEventListener("cart:update", function () {
        self.refresh();
      });

      // Native Shopify add-to-cart events lopen soms buiten onze eigen events.
      var onNativeAdd = function () {
        self.refresh().then(function () { self.open(); });
      };
      document.documentElement.addEventListener("variant:add", onNativeAdd);
      document.documentElement.addEventListener("cart:change", onNativeAdd);

      // --- Cart-link interceptor ---
      // Vang elke klik op "/cart" (header-icon, mobile menu, etc.) op en open
      // de drawer ipv te navigeren naar de Shopify /cart-pagina. Uitzonderingen:
      //   * cmd/ctrl/shift-klik (user wil nieuwe tab openen)
      //   * links met data-force-cart-page (admin override)
      //   * links met target="_blank"
      //   * het checkout-pad /cart/checkout of /cart/add (blijven navigeren)
      document.addEventListener("click", function (e) {
        var link = e.target.closest("a[href]");
        if (!link) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        if (link.hasAttribute("data-force-cart-page")) return;
        if (link.target === "_blank") return;

        var url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch (_) {
          return;
        }
        if (url.origin !== window.location.origin) return;

        // Match exact /cart (met optionele locale prefix zoals /nl/cart)
        var path = url.pathname.replace(/\/$/, "");
        var isCartPath = path === "/cart" || /\/cart$/.test(path);
        if (!isCartPath) return;

        e.preventDefault();
        self.refresh().then(function () {
          self.open();
        });
      });
    },

    _overrideTabLabels: function () {
      var drawer = this.drawer || document.getElementById("cart-drawer");
      if (!drawer) return;

      var cartTab = drawer.querySelector('[data-cart-tab="cart"]');
      var giftsTab = drawer.querySelector('[data-cart-tab="gifts"]');
      if (cartTab) {
        var count = cartTab.querySelector("[data-cart-count]");
        cartTab.childNodes.forEach(function (node) {
          if (node.nodeType === 3) node.nodeValue = "";
        });
        cartTab.insertBefore(
          document.createTextNode((CART_T.cart || "Cart") + " "),
          count || cartTab.firstChild,
        );
        if (count && count.parentNode !== cartTab) cartTab.appendChild(count);
      }
      if (giftsTab) {
        giftsTab.textContent = CART_T.gifts || CART_T.freeGifts || "Gifts";
        giftsTab.setAttribute(
          "aria-label",
          CART_T.freeGifts || CART_T.gifts || "Free gifts",
        );
      }
    },

    _bindThemeEditorEvents: function () {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      if (this._themeEditorEventsBound) return;
      this._themeEditorEventsBound = true;

      var self = this;
      var rerender = function () {
        setTimeout(function () {
          self.drawer = document.getElementById("cart-drawer") || self.drawer;
          self.overlay = document.getElementById("cart-overlay") || self.overlay;
          self.body = self.drawer && self.drawer.querySelector("[data-cart-body]");
          self._loadGiftTierSettings();
          self._overrideRewardAndGifts();
          self._syncGiftAndMaybeRefresh();
        }, 120);
      };

      document.addEventListener("shopify:section:load", rerender);
      document.addEventListener("shopify:section:select", rerender);
      document.addEventListener("shopify:block:select", rerender);
      document.addEventListener("shopify:block:deselect", rerender);
    },

    // ---------- Open / close ----------
    isOpen: function () {
      return this.drawer && this.drawer.classList.contains("is-open");
    },

    open: function () {
      if (!this.drawer) return;
      var self = this;
      // Loopt er een refresh (bijv. direct na "In winkelwagen")? Dan pas
      // openen als die klaar is: geen oude inhoud die tijdens het openschuiven
      // wordt vervangen, en het drempelcadeau staat er meteen bij.
      if (self._refreshPromise && !self._openWachtend) {
        self._openWachtend = true;
        var klaar = false;
        var doorgaan = function () { if (klaar) return; klaar = true; self._openWachtend = false; self._openNu(); };
        self._refreshPromise.then(doorgaan, doorgaan);
        setTimeout(doorgaan, 1500);
        return;
      }
      self._openNu();
    },

    _openNu: function () {
      if (!this.drawer) return;
      this.drawer.classList.add("is-open");
      // Voor koopknoppen die "Toegevoegd" tonen tot de drawer echt open is.
      document.dispatchEvent(new CustomEvent("cart:opened", { bubbles: true }));
      this.overlay.classList.add("is-open");
      this.drawer.setAttribute("aria-hidden", "false");
      this.overlay.setAttribute("aria-hidden", "false");
      document.body.classList.add("cart-drawer-open");
      document.body.style.overflow = "hidden";

      var self = this;
      setTimeout(function () {
        self._loadGiftTierSettings();
        self._overrideRewardAndGifts();
        self._syncGiftAndMaybeRefresh();
      }, 150);
    },

    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      this.overlay.classList.remove("is-open");
      this.drawer.setAttribute("aria-hidden", "true");
      this.overlay.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cart-drawer-open");
      document.body.style.overflow = "";
    },

    // ---------- AJAX helpers ----------
    _addToCart: function (variantId, quantity) {
      var fd = new FormData();
      fd.append("id", variantId);
      fd.append("quantity", quantity || 1);
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: fd,
      })
        .then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        })
        .then(function (res) {
          return CartDrawer.refresh().then(function () {
            return res;
          });
        });
    },

    // ---------- Optimistische aantal-update + gebundelde wijziging ----------
    // Regel zacht inklappen: hoogte naar 0 met overgang, zodat de rest van
    // de lijst direct opschuift (de server-render ruimt hem daarna op).
    _collapseRow: function (item) {
      if (!item || item.classList.contains("is-collapsing")) return;
      item.classList.add("is-collapsing");
      // Spiegel van het inschuiven (oduree-row-in): hoogte en padding van de
      // regel meegeven aan de keyframe via custom properties.
      var cs = window.getComputedStyle(item);
      item.style.setProperty("--row-h", item.offsetHeight + "px");
      item.style.setProperty("--row-pt", cs.paddingTop);
      item.style.setProperty("--row-pb", cs.paddingBottom);
      item.classList.add("is-removing");
    },

    _bumpCount: function (delta) {
      var el = this.drawer && this.drawer.querySelector("[data-cart-count]");
      if (!el || !delta) return;
      var n = parseInt(String(el.textContent).replace(/[^0-9]/g, ""), 10) || 0;
      el.textContent = String(Math.max(0, n + delta));
      CartDrawer.updateNavBadge(Math.max(0, n + delta));
    },

    _optimisticQty: function (item, oldQty, newQty) {
      item.setAttribute("data-qty", String(newQty));
      this._bumpCount(newQty - oldQty);
      var bump = function (el, text) {
        if (!el) return;
        if (text != null) el.textContent = text;
        el.classList.remove("is-bump");
        void el.offsetWidth; // herstart animatie
        el.classList.add("is-bump");
      };
      bump(item.querySelector("[data-qty-display]"), String(newQty));
      // Alleen het aantal verandert meteen. Prijs, totaal, mijlpaalbalk en drempelcadeau wachten op
      // de echte stand van Shopify: bij een ander aantal kan een actie of bundelkorting in- of uitgaan
      // (1+1, Instant Crush, 2 stuks 10%), en een schatting met de oude stukprijs schoot eerst door
      // en sprong daarna terug (Lucas 2-11: "dit blokje doet nog veel gespring"). Tot de nieuwe
      // render staan regelprijs en totaal gedimd (custom.css, is-updating).
      var totalEl = this.drawer && this.drawer.querySelector("[data-cart-total]");
      if (totalEl) totalEl.classList.add("is-updating");
      item.classList.add("is-updating");
      item.classList.toggle("is-removing", newQty === 0);
      if (newQty === 0) this._collapseRow(item);
    },

    _qualifyingFromDom: function () {
      var som = 0;
      var rows = this.drawer ? this.drawer.querySelectorAll("[data-cart-item]") : [];
      rows.forEach(function (row) {
        if (row.hasAttribute("data-cart-gift-item") || row.hasAttribute("data-gift-paid") || row.classList.contains("cart-drawer__item--gift") || row.classList.contains("cart-drawer__item--punten")) return;
        if (row.classList.contains("is-removing")) return;
        // Regelbedrag ná kortingen zoals Shopify het afrondt (data-line-price); stukprijs x aantal
        // week soms 1 cent af en liet de balktekst daarna nog een keer wisselen.
        var regel = parseInt(row.getAttribute("data-line-price"), 10);
        if (!isNaN(regel)) { som += regel; return; }
        var qty = parseInt(row.getAttribute("data-qty"), 10) || 0;
        var unit = parseInt(row.getAttribute("data-unit-price"), 10) || 0;
        som += qty * unit;
      });
      return som;
    },

    // Drempelcadeau direct tonen/verbergen bij de klik: een tijdelijke regel
    // schuift in zodra de drempel gehaald is; de echte regel (na de sync met
    // Shopify) neemt hem zonder tweede animatie over (zelfde variant-id).
    // Sinds 2-11 niet meer aangeroepen (zie _optimisticQty): het drempelcadeau komt mee met de echte render.
    _optimisticGift: function (totaal) {
      var self = this;
      if (!self.drawer) return;
      var lijst = self.drawer.querySelector("[data-cart-items]");
      if (!lijst) return;
      var heeftAbo = !!lijst.querySelector(".cart-drawer__item-plan");
      var tiers = MILESTONES.filter(function (m) { return m.type === "gift" && m.variantId; });
      // Hoogste drempel eerst invoegen: elke nieuwe regel komt bovenaan, zodat
      // de volgorde in de lijst oploopt met de drempel (mug boven paraplu).
      tiers.slice().sort(function (a, b) { return b.threshold - a.threshold; }).forEach(function (tier) {
        // Alleen een echte cadeauregel telt (data-cart-gift-item): dezelfde
        // variant kan ook los gekocht of met punten ingewisseld in de cart staan.
        var bestaand = lijst.querySelector('[data-cart-item][data-cart-gift-item][data-variant-id="' + tier.variantId + '"]');
        var gewenst = !heeftAbo && totaal >= tier.threshold;
        if (gewenst && bestaand && bestaand.classList.contains("is-removing")) {
          // Eerder ingeklapt, nu toch weer gewenst: enkel een pending-regel
          // kan veilig terug; een echte regel komt met de server-render terug.
          if (bestaand.classList.contains("is-pending-gift")) {
            bestaand.classList.remove("is-removing", "is-collapsing");
            self._bumpCount(1);
          }
          return;
        }
        if (gewenst && !bestaand) {
          var img = tier.image || _giftImageCache[tier.productHandle] || "";
          var titel = String(tier.label || "").replace(/^(gratis|free)\s+/i, "");
          var chip = interpolate(copyValue(CART_T.tierGiftLabel, "Gift from [amount]"), { amount: formatMoney(tier.threshold).replace(/[,.]00\b/, "") });
          var rij = document.createElement("div");
          rij.className = "cart-drawer__item cart-drawer__item--gift is-new is-pending-gift";
          rij.setAttribute("data-cart-item", "");
          rij.setAttribute("data-cart-gift-item", "");
          rij.setAttribute("data-key", "pending-gift-" + tier.variantId);
          rij.setAttribute("data-variant-id", tier.variantId);
          rij.setAttribute("data-qty", "1");
          rij.setAttribute("data-unit-price", "0");
          rij.innerHTML =
            '<span class="cart-drawer__item-img">' + (img ? '<img src="' + escapeHtml(img) + '" alt="" width="72" height="72">' : "") + "</span>" +
            '<div class="cart-drawer__item-info"><span class="cart-drawer__item-name">' + escapeHtml(titel) + "</span>" +
            '<div class="cart-drawer__item-bottom"><span class="cart-drawer__item-gift-label">' + escapeHtml(chip) + "</span>" +
            '<div class="cart-drawer__item-prices"><span class="cart-drawer__item-price cart-drawer__item-price--free">' + escapeHtml(CART_T.freePrice || "FREE") + "</span></div></div></div>";
          lijst.insertBefore(rij, lijst.firstChild);
          self._bumpCount(1);
          rij.addEventListener("animationend", function () { rij.classList.remove("is-new"); }, { once: true });
        } else if (!gewenst && bestaand && !bestaand.classList.contains("is-removing")) {
          bestaand.classList.add("is-removing");
          self._collapseRow(bestaand);
          self._bumpCount(-(parseInt(bestaand.getAttribute("data-qty"), 10) || 1));
          if (bestaand.classList.contains("is-pending-gift")) {
            setTimeout(function () { if (bestaand.parentNode && bestaand.classList.contains("is-removing")) bestaand.parentNode.removeChild(bestaand); }, 320);
          }
        }
      });
    },

    _queueChange: function (key, line, quantity) {
      var self = this;
      self._pendingChanges = self._pendingChanges || {};
      self._pendingChanges[key || ("line:" + line)] = { key: key, line: line, quantity: quantity };
      clearTimeout(self._pendingTimer);
      self._pendingTimer = setTimeout(function () { self._flushChanges(); }, 260);
    },

    _flushChanges: function () {
      var self = this;
      if (self._flushing) { self._flushAgain = true; return Promise.resolve(); }
      var pending = self._pendingChanges || {};
      self._pendingChanges = {};
      var entries = Object.keys(pending).map(function (k) { return pending[k]; });
      if (!entries.length) return Promise.resolve();
      self._flushing = true;
      var metKey = entries.filter(function (c) { return c.key; });
      var zonderKey = entries.filter(function (c) { return !c.key; });
      var chain;
      if (metKey.length) {
        var updates = {};
        metKey.forEach(function (c) { updates[c.key] = c.quantity; });
        chain = fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) { if (!r.ok) throw new Error("update failed"); return r.json(); });
      } else {
        chain = Promise.resolve();
      }
      zonderKey.forEach(function (c) {
        chain = chain.then(function () { return self._changeLine(c.line, c.quantity, null, true); });
      });
      return chain
        .catch(function (err) { console.warn("[CartDrawer] wijziging mislukt", err); })
        // Drempelcadeau in dezelfde ronde bijwerken (toevoegen boven de
        // drempel, weghalen eronder) vóór de drawer opnieuw rendert. Anders
        // staat de mug een paar seconden tegen de volle prijs in beeld
        // (functie geeft geen korting meer) tot de sync na de render hem
        // weghaalt, of verdwijnt de tijdelijke regel even tot hij echt is
        // toegevoegd.
        .then(function () { return CartDrawer.refresh(); })
        .then(function () {
          self._flushing = false;
          if (self._flushAgain) { self._flushAgain = false; return self._flushChanges(); }
        });
    },

    _changeLine: function (line, quantity, key, skipRefresh) {
      return fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(key ? { id: key, quantity: quantity } : { line: line, quantity: quantity }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("change failed");
          return r.json();
        })
        .then(function () {
          if (skipRefresh) return;
          return CartDrawer.refresh();
        });
    },

    // ---------- Dedupe duplicate cart lines ----------
    // Shopify MOET zelf mergen als variant_id + properties + selling_plan
    // identiek zijn, maar door third-party apps, race-conditions of
    // legacy line-properties kunnen er soms twee lines van hetzelfde
    // product in de cart komen. Deze helper voegt ze atomair samen
    // via /cart/update.js met de array-form van `updates`: we lezen alle
    // line-quantities uit, groeperen op identity-key, en zetten duplicates
    // terug naar 0 terwijl de eerste line de som van alle quantities krijgt.
    // Loopt bij elke refresh. Returnt { action:'deduped' } als er merged is
    // (zodat caller een extra UI-refresh kan doen), null als er niks te
    // doen was.
    _dedupeDuplicateLines: function () {
      return leesCart()
        .then(function (cart) {
          if (!cart || !cart.items || cart.items.length < 2) return null;

          // Bouw identity-key per item. Twee lines met dezelfde key
          // betekent "echte duplicaten" en mogen samengevoegd worden.
          var groups = {};
          cart.items.forEach(function (item, idx) {
            var propsKey = JSON.stringify(item.properties || {});
            var spId = "";
            if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
              spId = String(item.selling_plan_allocation.selling_plan.id || "");
            }
            // Kortingsstaat hoort bij de identiteit van een regel. Shopify
            // splitst bij een "koop 2, krijg 1 gratis" dezelfde variant in twee
            // regels: een betaalde en een gratis. Zonder dit stuk zag de
            // samenvoeger die als duplicaten, plakte ze aan elkaar en zette de
            // gratis regel op 0. De klant hield dan twee stuks tegen volle
            // prijs over en de korting verdween.
            var kortingKey = "0";
            if (item.total_discount) {
              kortingKey = String(item.total_discount);
            } else if (item.line_level_discount_allocations && item.line_level_discount_allocations.length) {
              kortingKey = "L" + item.line_level_discount_allocations.length;
            } else if (item.discounts && item.discounts.length) {
              kortingKey = "D" + item.discounts.length;
            }
            var key = String(item.variant_id) + "|" + propsKey + "|" + spId + "|" + kortingKey;
            if (!groups[key]) groups[key] = [];
            groups[key].push({ lineIndex: idx, qty: item.quantity });
          });

          // Start met huidige quantities; pas aan per duplicate-groep.
          var newQties = cart.items.map(function (it) { return it.quantity; });
          var hasChanges = false;
          Object.keys(groups).forEach(function (key) {
            var group = groups[key];
            if (group.length <= 1) return;
            hasChanges = true;
            var total = group.reduce(function (a, g) { return a + g.qty; }, 0);
            // Eerste line houdt het totaal, rest op 0.
            newQties[group[0].lineIndex] = total;
            for (var i = 1; i < group.length; i++) {
              newQties[group[i].lineIndex] = 0;
            }
          });

          if (!hasChanges) return null;
          console.info("[CartDrawer] Duplicate cart lines gedetecteerd, samenvoegen...", newQties);
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ updates: newQties }),
          }).then(function (r) {
            return r.ok ? { action: "deduped" } : null;
          });
        })
        .catch(function (err) {
          console.warn("[CartDrawer] dedupe error", err);
          return null;
        });
    },

    _loadGiftTierSettings: function () {
      var source = this.drawer && this.drawer.querySelector("[data-oduree-gift-tiers]");
      var tiers = [];
      if (source && source.textContent) {
        try {
          tiers = JSON.parse(source.textContent) || [];
        } catch (err) {
          console.warn("[CartDrawer] gift tier config kon niet gelezen worden", err);
        }
      }
      if ((!tiers || !tiers.length) && window.ODUREE_GIFT_TIERS && window.ODUREE_GIFT_TIERS.length) {
        tiers = window.ODUREE_GIFT_TIERS;
        if (source) source.textContent = JSON.stringify(tiers);
      }

      GIFT_TIERS = tiers
        .filter(function (tier) {
          var handle = String((tier && tier.productHandle) || "").toLowerCase();
          return tier &&
            tier.enabled &&
            parseInt(tier.threshold, 10) > 0 &&
            PAUSED_GIFT_HANDLES.indexOf(handle) === -1;
        })
        .map(function (tier, idx) {
          return {
            key: String(tier.key || ("gift-" + idx)),
            threshold: toPresentmentCents(tier.threshold),
            label: tier.label || ("Gift " + (idx + 1)),
            desc: tier.desc || "",
            productHandle: tier.productHandle || "",
            variantId: tier.variantId ? String(tier.variantId) : "",
            image: tier.image || "",
            type: "gift",
          };
        })
        .sort(function (a, b) { return a.threshold - b.threshold; });

      MILESTONES = GIFT_TIERS.length ? GIFT_TIERS.slice() : FALLBACK_MILESTONES.slice();
      return GIFT_TIERS;
    },

    // ---------- Dynamische gift tiers ----------
    // Sync de cadeauproducten die in de theme customizer als Gift tier block staan.
    _resolveGiftTierVariants: function (tiers) {
      var missing = (tiers || []).filter(function (tier) {
        return tier && !tier.variantId && tier.productHandle;
      });
      if (!missing.length) return Promise.resolve(tiers);

      var lookups = missing.map(function (tier) {
        return fetch("/products/" + tier.productHandle + ".js", {
          cache: "no-store",
          headers: { Accept: "application/json" },
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) {
            if (!product || !product.variants || !product.variants.length) return;
            var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
            if (variant && variant.id) tier.variantId = String(variant.id);
            if ((!tier.label || /^Gift \d+$/.test(tier.label)) && product.title) tier.label = product.title;
            if (!tier.image && product.featured_image) {
              tier.image = product.featured_image;
              _giftImageCache[tier.productHandle] = product.featured_image;
            }
          })
          .catch(function () {});
      });

      return Promise.all(lookups).then(function () {
        MILESTONES = GIFT_TIERS.length ? GIFT_TIERS.slice() : FALLBACK_MILESTONES.slice();
        return tiers;
      });
    },

    _syncGiftAndMaybeRefresh: function () {
      var self = this;
      // GUARD: Oduree Gifts App is actief (shop metafield gevuld) die
      if (self._giftSyncInProgress) return Promise.resolve();
      self._giftSyncInProgress = true;
      self._loadGiftTierSettings();
      return self._syncGiftTiers().then(function (tierRes) {
        return self._syncBundleGift().then(function (bundleRes) {
          return self._syncWelkomstcadeaus().then(function (wcgRes) {
            return tierRes || bundleRes || wcgRes;
          });
        });
      }).then(function (res) {
        self._giftSyncInProgress = false;
        // Null = geen wijziging; object = cart is veranderd re-render
        if (res && !self._giftSyncInProgress) {
          return self.refresh();
        }
      }).catch(function (err) {
        self._giftSyncInProgress = false;
        console.warn("[CartDrawer] gift sync error", err);
      });
    },

    _syncBundleGift: function () {
      // Variant-ID van de sleutelhanger uit de drawer-settings (100%-korting
      // via de Shopify BXGY-discount). Leeg attribuut of ontbrekend element =
      // feature uit → stale gift-regels worden dan opgeruimd.
      var giftVariantEl = document.querySelector("[data-bundle-gift-variant-id]");
      var giftVariantId = giftVariantEl
        ? String(giftVariantEl.getAttribute("data-bundle-gift-variant-id") || "").trim()
        : "";
      var giftEnabled = /^\d+$/.test(giftVariantId);

      return leesCart()
        .then(function (cart) {
          if (!cart || !cart.items) return null;

          var duoQuantity = 0;
          var giftLines = [];

          cart.items.forEach(function (item) {
            if (isBundleGiftLine(item)) {
              giftLines.push({
                key: item.key,
                quantity: parseInt(item.quantity, 10) || 0,
              });
              return;
            }

            if (isBundleDuoLine(item)) {
              duoQuantity += parseInt(item.quantity, 10) || 0;
            }
          });

          if (!giftEnabled) {
            if (!giftLines.length) return null;

            var removeChain = Promise.resolve();
            giftLines.forEach(function (line) {
              if (!line.quantity) return;
              removeChain = removeChain.then(function () {
                return fetch("/cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json", Accept: "application/json" },
                  body: JSON.stringify({ id: line.key, quantity: 0 }),
                });
              });
            });

            return removeChain.then(function () { return { action: "bundle-gift-disabled" }; });
          }

          // EXACT 2 duo-bundel-stuks → 1 gratis sleutelhanger; anders geen.
          // Past de klant de aantallen aan (duo-regel wordt 1 of 3+), dan
          // verdwijnt de sleutelhanger direct — de BXGY-korting dekt hem
          // dan niet meer en hij mag nooit betaald in de cart blijven.
          var desiredGiftQuantity = duoQuantity === BUNDLE_GIFT_QTY_TRIGGER ? 1 : 0;
          var changes = [];

          giftLines.forEach(function (line, idx) {
            var targetQuantity = idx === 0 ? desiredGiftQuantity : 0;
            if (line.quantity !== targetQuantity) {
              changes.push({ id: line.key, quantity: targetQuantity });
            }
          });

          var shouldAddGift = desiredGiftQuantity > 0 && !giftLines.length;
          var chain = Promise.resolve();

          changes.forEach(function (change) {
            chain = chain.then(function () {
              return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(change),
              });
            });
          });

          if (shouldAddGift) {
            chain = chain.then(function () {
              return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({
                  items: [{
                    id: giftVariantId,
                    quantity: desiredGiftQuantity,
                    properties: {
                      _oduree_gift: "true",
                      _oduree_gift_tier: BUNDLE_GIFT_KEY,
                      _oduree_gift_label: "Gratis Alcantara Sleutelhanger",
                      _oduree_gift_threshold: "parfum-duo",
                    },
                  }],
                }),
              });
            });
          }

          if (!changes.length && !shouldAddGift) return null;
          return chain.then(function () { return { action: "bundle-gift-synced" }; });
        });
    },

    _syncWelkomstcadeaus: function () {
      // Welkomstcadeaus (_oduree_wcg) volgen het abonnementsniveau in de cart.
      // Cadeauladder (Starter = alleen e-Book, digitaal, geen cartregel):
      //   Autoparfum Sample 5 ml  — vanaf Duo (hanger én spray met plan)
      //   Alcantara Sleutelhanger — alleen volledige Quattro (≥2 hangers én ≥2 sprays met plan)
      //   Gift Box / Speelkaarten — vervallen als cadeau: altijd opruimen (legacy)
      // Schaalt de klant zijn abonnement in de drawer terug (of weg), dan
      // verdwijnen de cadeaus waar geen recht meer op is — anders blijven ze
      // als betaalde regels achter zodra de €0-dekking wegvalt. Bewust alleen
      // afschalen: toevoegen doet de koopknop op de PDP, zodat een bewust
      // verwijderd cadeau niet terug blijft springen.
      return leesCart()
        .then(function (cart) {
          if (!cart || !cart.items) return null;

          var planHanger = 0;
          var planSpray = 0;
          var planTotal = 0;
          var wcgLines = [];
          cart.items.forEach(function (item) {
            if (String(getLineProperty(item, "_oduree_wcg") || "").toLowerCase() === "true") {
              wcgLines.push({ key: item.key, handle: String(item.handle || ""), quantity: item.quantity || 1 });
            } else if (item.selling_plan_allocation) {
              planTotal += item.quantity;
              if (item.handle === "autoparfum-hanger") planHanger += item.quantity;
              if (item.handle === "autoparfum-spray") planSpray += item.quantity;
            }
          });

          var changes = [];
          wcgLines.forEach(function (line) {
            var entitled;
            if (line.handle === "autoparfum-spray") entitled = planHanger >= 1 && planSpray >= 1;
            else if (line.handle === "alcantara-sleutelhanger") entitled = planHanger >= 2 && planSpray >= 2;
            else entitled = false;
            if (!entitled) changes.push({ key: line.key, qty: 0 });
            else if (line.quantity > 1) changes.push({ key: line.key, qty: 1 });
          });

          if (!changes.length) return null;

          var chain = Promise.resolve();
          changes.forEach(function (change) {
            chain = chain.then(function () {
              return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ id: change.key, quantity: change.qty }),
              });
            });
          });

          return chain.then(function () { return { action: "wcg-removed" }; });
        });
    },

    _syncGiftTiers: function () {
      var self = this;
      var tiers = this._loadGiftTierSettings();
      return self._resolveGiftTierVariants(tiers).then(function (resolvedTiers) {
        var giftTiersWithVariants = resolvedTiers.filter(function (tier) {
          return tier.variantId;
        });

        return leesCart()
        .then(function (cart) {
          if (!cart || !cart.items) return null;

          // Abonnementscart: geen drempelcadeaus (de app-functie geeft daar
          // ook geen korting, dus een cadeau zou betaald blijven staan).
          var heeftAbo = cart.items.some(function (item) { return !!item.selling_plan_allocation; });

          var qualifyingTotal = 0;
          var giftLinesByVariant = {};
          cart.items.forEach(function (item) {
            if (isGiftTierLine(item)) {
              var vid = String(item.variant_id);
              if (!giftLinesByVariant[vid]) giftLinesByVariant[vid] = [];
              giftLinesByVariant[vid].push({
                key: item.key,
                quantity: item.quantity,
              });
            } else {
              // Ná kortingen (Lucas 27-10: de mug pas vanaf €60 van wat de klant echt betaalt): de regel-
              // prijs na bundelkorting en andere regelkortingen; kortingen op de hele wagen gaan er na de
              // lus af. De functie drempel-cadeau toetst ruimer (vóór kortingen), zodat een cadeau dat de
              // lade terecht toevoegt daar altijd gratis is. Andere cadeauregels (kraskaart, welkomst-
              // cadeau, punten, bundelsleutelhanger) en Verzekerde Verzending tellen niet mee.
              var pr = item.properties || {};
              var isAnderCadeau = pr._oduree_wcg || pr._oduree_punten || pr._oduree_kraskaart === "true" || pr._oduree_kraskaart_sample === "true" || isCartGiftLine(item) || isVerzekering(item);
              if (!isAnderCadeau) qualifyingTotal += item.final_line_price || 0;
            }
          });

          qualifyingTotal = Math.max(0, qualifyingTotal - wagenKorting(cart));
          var desired = {};
          if (!heeftAbo) {
            giftTiersWithVariants.forEach(function (tier) {
              if (qualifyingTotal >= tier.threshold) desired[String(tier.variantId)] = tier;
            });
          }

          var changes = [];
          Object.keys(giftLinesByVariant).forEach(function (variantId) {
            var lines = giftLinesByVariant[variantId];
            if (!desired[variantId]) {
              lines.forEach(function (line) {
                changes.push({ id: line.key, quantity: 0 });
              });
              return;
            }

            lines.forEach(function (line, idx) {
              var targetQty = idx === 0 ? 1 : 0;
              if (line.quantity !== targetQty) {
                changes.push({ id: line.key, quantity: targetQty });
              }
            });
          });

          var toAdd = Object.keys(desired)
            .filter(function (variantId) {
              return !giftLinesByVariant[variantId] || !giftLinesByVariant[variantId].length;
            })
            .map(function (variantId) {
              var tier = desired[variantId];
              return {
                id: variantId,
                quantity: 1,
                properties: {
                  _oduree_gift: "true",
                  _oduree_gift_tier: tier.key,
                  _oduree_gift_label: tier.label,
                  _oduree_gift_threshold: String(tier.threshold),
                },
              };
            });

          var chain = Promise.resolve();
          changes.forEach(function (change) {
            chain = chain.then(function () {
              return fetch("/cart/change.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(change),
              });
            });
          });

          if (toAdd.length) {
            chain = chain.then(function () {
              return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify({ items: toAdd }),
              });
            });
          }

          if (!changes.length && !toAdd.length) return null;
          return chain.then(function () { return { action: "gift-tiers-synced" }; });
        });
      });
    },

    // Laadt product-data voor elke milestone met productHandle en cachet
    // de featured_image URL. Na load: roept refresh() aan zodat het paneel
    // opnieuw rendert met de echte thumbnail (vervangt SVG-fallback).
    _loadGiftImages: function () {
      var self = this;
      this._loadGiftTierSettings();
      MILESTONES.forEach(function (m) {
        if (m.productHandle && m.image) _giftImageCache[m.productHandle] = m.image;
      });
      var handles = MILESTONES
        .filter(function (m) { return m.productHandle; })
        .map(function (m) { return m.productHandle; });
      if (!handles.length) return Promise.resolve();
      var promises = handles.map(function (h) {
        if (_giftImageCache[h]) return Promise.resolve(_giftImageCache[h]);
        return fetch("/products/" + h + ".js")
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p && p.featured_image) {
              _giftImageCache[h] = p.featured_image;
            }
            return _giftImageCache[h] || null;
          })
          .catch(function () { return null; });
      });
      return Promise.all(promises).then(function () {
        // Re-render reward-bar + gift-paneel zodra image-data binnen is,
        // zodat de echte thumbnail de SVG-fallback vervangt. Werkt alleen
        // als drawer al geinitialiseerd is.
        if (self.drawer && typeof self._overrideRewardAndGifts === "function") {
          self._overrideRewardAndGifts();
        }
      });
    },

    // ---------- MILESTONES OVERLAY (JS-workaround voor liquid sync-lag) ----------
    // Overrulet de reward-bar tekst/progress/ticks en vult het Cadeaus-
    // paneel aan met de juiste milestones (incl. Kaartenspel m4), onafhan-
    // kelijk van wat de server-side Liquid rendert. Idempotent - mag na
    // elke refresh opnieuw gedraaid worden.
    _overrideRewardAndGifts: function () {
      var drawer = this.drawer;
      if (!drawer) return;
      this._loadGiftTierSettings();

      // Haal cart_total op uit de DOM (data-cart-total) als beschikbaar -
      // anders async via cart.js. We gebruiken SYNCHRONOUS DOM-read zodat
      // de UI direct klopt; _updateWithCartTotal doet exact renderen.
      var totalEl = drawer.querySelector("[data-cart-total]");
      // Liquid rendert bv. "€ 71,75" - parse naar cents.
      var parsed = this._parseMoneyToCents(totalEl ? totalEl.textContent : "");
      var self = this;
      // Meteen uit de DOM, in dezelfde taak als de render: geen flits van de
      // Liquid-bedragen (die kennen geen wisselkoers; op oduree.com stond
      // anders even "£45" in plaats van het omgerekende bedrag).
      if (totalEl) {
        try { this._applyRewardBarOverride(this._qualifyingFromDom(), parsed); } catch (_) {}
      }
      // Altijd async bevestigen via cart.js (betrouwbare bron).
      leesCart()
        .then(function (cart) {
          // Twee bedragen, allebei ná kortingen: cadeaus = wat de klant voor zijn artikelen betaalt,
          // zonder cadeauregels en Verzekerde Verzending (zoals _syncGiftTiers); gratis verzending =
          // total_price, waarop Shopify het verzendtarief toetst. Een drempelcadeau dat (nog) niet
          // op €0 staat telt nergens mee: de sync haalt het weg.
          var qualifyingTotal = 0;
          var shippingTotal = cart.total_price || 0;
          cart.items.forEach(function (it) {
            var pr = it.properties || {};
            if (pr._oduree_gift_tier) shippingTotal -= it.final_line_price || 0;
            if (isCartGiftLine(it)) return;
            if (pr._oduree_wcg || pr._oduree_punten || pr._oduree_kraskaart === "true" || pr._oduree_kraskaart_sample === "true" || isVerzekering(it)) return;
            qualifyingTotal += it.final_line_price || 0;
          });
          qualifyingTotal = Math.max(0, qualifyingTotal - wagenKorting(cart));
          shippingTotal = Math.max(0, shippingTotal);
          self._applyRewardBarOverride(qualifyingTotal, shippingTotal);
          self._applyCadeautjePanelOverride(qualifyingTotal, shippingTotal);
        })
        .catch(function () {
          if (parsed != null) {
            self._applyRewardBarOverride(parsed, parsed);
            self._applyCadeautjePanelOverride(parsed, parsed);
          }
        });
    },

    _parseMoneyToCents: function (text) {
      if (!text) return null;
      // "€71,75", "£71.75", "€1.071,75" en "£1,071.75": een punt of komma met
      // precies twee cijfers aan het eind is het decimaalteken, andere
      // punten en komma's zijn duizendtallen.
      var clean = String(text).replace(/[^0-9,.]/g, "");
      if (!/\d/.test(clean)) return null;
      var m = clean.match(/^(.*)[.,](\d{2})$/);
      var heel = parseInt((m ? m[1] : clean).replace(/[.,]/g, "") || "0", 10);
      return heel * 100 + (m ? parseInt(m[2], 10) : 0);
    },

    // Mijlpaalknopen voor de balk: gratis verzending + alle cadeau-tiers,
    // gesorteerd op drempel. Knoop i (vanaf 0) staat op (i+1)/N x 100%;
    // de vulling loopt per segment lineair (zelfde rekenregel als de Liquid
    // in sections/cart-drawer.liquid, tot op 2 decimalen).
    _rewardBarNodes: function () {
      var shippingThreshold =
        (FALLBACK_MILESTONES[0] && FALLBACK_MILESTONES[0].threshold) ||
        toPresentmentCents(BASE_FREE_SHIPPING_THRESHOLD_CENTS);
      var nodes = [];
      if (shippingThreshold > 0) {
        nodes.push({ threshold: shippingThreshold, label: CART_T.freeShippingLabel || "Free shipping", type: "shipping" });
      }
      MILESTONES.forEach(function (m) {
        if (m.type === "gift" && m.threshold > 0) nodes.push({ threshold: m.threshold, label: m.label, type: "gift", tier: m });
      });
      nodes.sort(function (a, b) { return a.threshold - b.threshold; });
      var n = Math.max(1, nodes.length);
      var step = 100 / n;
      nodes.forEach(function (node, i) {
        node.pct = Math.min(100, Math.round((i + 1) * step * 100) / 100);
      });
      return { nodes: nodes, step: step };
    },

    // Bedrag waarop een knoop toetst: gratis verzending op het bedrag ná
    // kortingen, een cadeau op de waarde vóór kortingen. totals is
    // { gift, ship } of één getal voor allebei.
    _nodeTotal: function (node, totals) {
      if (totals == null || typeof totals !== "object") return totals || 0;
      return node && node.type === "shipping" ? totals.ship : totals.gift;
    },

    _rewardBarProgress: function (nodes, step, totals) {
      var nextIndex = -1;
      var prev = 0;
      for (var i = 0; i < nodes.length; i++) {
        if (this._nodeTotal(nodes[i], totals) < nodes[i].threshold) { nextIndex = i; break; }
        prev = nodes[i].threshold;
      }
      if (nextIndex < 0) return { pct: 100, next: null, nextIndex: -1, remaining: 0 };
      var bedrag = this._nodeTotal(nodes[nextIndex], totals);
      var seg = Math.max(1, nodes[nextIndex].threshold - prev);
      var done = Math.max(0, bedrag - prev);
      var pct = nextIndex * step + (done * step) / seg;
      pct = Math.round(pct * 100) / 100;
      return { pct: Math.max(0, Math.min(100, pct)), next: nodes[nextIndex], nextIndex: nextIndex, remaining: nodes[nextIndex].threshold - bedrag };
    },

    // "A, B en C": alle beloningen vet, laatste met het voegwoord (listAnd).
    _rewardListHtml: function (nodes) {
      var and = " " + (CART_T.listAnd || "and") + " ";
      return nodes.map(function (node, i) {
        var sep = i === 0 ? "" : (i === nodes.length - 1 ? and : ", ");
        return sep + "<strong>" + escapeHtml(node.label) + "</strong>";
      }).join("");
    },

    // cartTotal = waarde vóór kortingen (cadeaus), shipTotal = bedrag ná
    // kortingen (gratis verzending); zonder shipTotal geldt cartTotal voor allebei.
    _applyRewardBarOverride: function (cartTotal, shipTotal) {
      var drawer = this.drawer;
      if (!drawer) return;
      var bar = drawer.querySelector("[data-cart-shipping], .cart-reward-bar");
      // De member-balk (gratis verzending via abonnement of punten) is statisch.
      if (!bar || bar.classList.contains("cart-reward-bar--member")) return;

      var self = this;
      var totals = { gift: cartTotal || 0, ship: shipTotal == null ? (cartTotal || 0) : shipTotal };
      var conf = this._rewardBarNodes();
      var nodes = conf.nodes;
      var heeftCadeau = nodes.some(function (n) { return n.type === "gift"; });
      var voortgang = this._rewardBarProgress(nodes, conf.step, totals);
      var progressPct = voortgang.pct;
      var next = voortgang.next;

      // Fill: vanaf de vorige breedte naar de nieuwe animeren (ook na een
      // her-render, waarbij het element nieuw is en anders hard zou springen).
      var fill = bar.querySelector("[data-ship-fill], .cart-reward-bar__fill");
      if (fill) {
        var vorigePct = this._barVorigePct;
        if (vorigePct != null && Math.abs(vorigePct - progressPct) > 0.01) {
          fill.style.transition = "none";
          fill.style.width = vorigePct + "%";
          void fill.offsetWidth;
          fill.style.transition = "";
        }
        fill.style.width = progressPct + "%";
      }
      this._barVorigePct = progressPct;
      bar.classList.toggle("is-complete", !next);

      var textEl = bar.querySelector(".cart-reward-bar__text");
      var tekstVoor = textEl ? textEl.textContent.replace(/\s+/g, " ").trim() : "";
      if (textEl) {
        if (!next) {
          if (heeftCadeau) {
            textEl.innerHTML = interpolate(
              copyValue(CART_T.tieredRewardsCompleteHtml, "[list] unlocked"),
              { list: this._rewardListHtml(nodes) },
            );
          } else {
            textEl.innerHTML = CART_T.shippingUnlockedHtml || "You have <strong>free shipping</strong>!";
          }
        } else if (next.type === "shipping") {
          textEl.innerHTML = interpolate(
            CART_T.shippingRemainingHtml || "<strong data-ship-amount>[amount]</strong> away from <strong>free shipping</strong>",
            { amount: formatMoney(voortgang.remaining), gift_hint: "" },
          );
        } else {
          textEl.innerHTML = interpolate(
            copyValue(CART_T.giftTierRemainingHtml, "Only [amount] away from <strong>[reward]</strong>."),
            { amount: formatMoney(voortgang.remaining), reward: escapeHtml(next.label) },
          );
        }
      }

      if (textEl && textEl.textContent.replace(/\s+/g, " ").trim() !== tekstVoor) {
        textEl.classList.remove("is-changed");
        void textEl.offsetWidth;
        textEl.classList.add("is-changed");
      }

      // Mijlpaal-knopen (verzending + cadeaus) met bedrag en label. Een knoop
      // die nét gehaald wordt, krijgt een korte pop.
      var nodesEl = bar.querySelector("[data-reward-nodes]");
      var eerderGehaald = this._barGehaald;
      var nuGehaald = {};
      if (nodesEl) {
        var check = '<span class="cart-reward-bar__dot" aria-hidden="true"><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.2l2.3 2.3 4.7-4.9"/></svg></span>';
        nodesEl.innerHTML = nodes.map(function (n, i) {
          var bedrag = formatMoney(n.threshold).replace(/[,.]00\b/, "");
          var gehaald = self._nodeTotal(n, totals) >= n.threshold;
          nuGehaald[n.threshold] = gehaald;
          var netGehaald = gehaald && eerderGehaald && !eerderGehaald[n.threshold];
          var laatste = i === nodes.length - 1;
          return '<div class="cart-reward-bar__node' + (gehaald ? " is-reached" : "") + (netGehaald ? " is-just-reached" : "") + (laatste ? " cart-reward-bar__node--last" : "") + '" style="left: ' + n.pct + '%">' + check +
            '<span class="cart-reward-bar__node-label"><b>' + escapeHtml(bedrag) + "</b>" + escapeHtml(n.label) + "</span></div>";
        }).join("");
        this._barGehaald = nuGehaald;
      }
    },

    _applyCadeautjePanelOverride: function (cartTotal, shipTotal) {
      var panel = this.drawer && this.drawer.querySelector("#cart-gift-panel");
      if (!panel) return;

      // Verwijder bestaande rijen en rebuild.
      panel.querySelectorAll(".cart-gift-item").forEach(function (el) { el.remove(); });

      var svgShipping =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="1" y="3" width="15" height="13" rx="1"/>' +
        '<path d="M16 8h4l3 5v3h-7V8z"/>' +
        '<circle cx="5.5" cy="18.5" r="2.5"/>' +
        '<circle cx="18.5" cy="18.5" r="2.5"/>' +
        "</svg>";
      var svgCard =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="4" y="2" width="12" height="18" rx="1.5"/>' +
        '<rect x="8" y="5" width="12" height="18" rx="1.5"/>' +
        "</svg>";
      var svgGift =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="20 12 20 22 4 22 4 12"/>' +
        '<rect x="2" y="7" width="20" height="5"/>' +
        '<line x1="12" y1="22" x2="12" y2="7"/>' +
        '<path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>' +
        '<path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>' +
        "</svg>";

      MILESTONES.forEach(function (m) {
        // Gratis verzending op het bedrag ná kortingen, cadeaus ervóór.
        var bedrag = (m.type === "shipping" || m.key === "m2") && shipTotal != null ? shipTotal : cartTotal;
        var reached = bedrag >= m.threshold;
        var row = document.createElement("div");
        row.className = "cart-gift-item" + (reached ? "" : " is-locked");

        // Image-URL komt uit _giftImageCache (gevuld door _loadGiftImages).
        // Als nog niet geladen: fallback naar SVG-gift-icoon. Na load wordt
        // het paneel opnieuw gerenderd met echte thumbnail.
        var visualHtml = "";
        if (m.productHandle && _giftImageCache[m.productHandle]) {
          var src = _giftImageCache[m.productHandle];
          // Shopify image URLs starten met // - ondersteun ook absolute https.
          var sep = src.indexOf("?") === -1 ? "?" : "&";
          var imgUrl = src + sep + "width=120";
          visualHtml =
            '<div class="cart-gift-item__img">' +
            '<img src="' + imgUrl + '" alt="' + escapeHtml(m.label) + '" width="52" height="52" loading="lazy">' +
            "</div>";
        }
        if (!visualHtml) {
          var svg = m.key === "m2" ? svgShipping : (m.key === "m4" ? svgCard : svgGift);
          visualHtml = '<div class="cart-gift-item__icon">' + svg + "</div>";
        }

        var descHtml;
        if (reached) {
          if (m.type === "shipping" || m.key === "m2") {
            descHtml = CART_T.shippingUnlockedHtml || "You have <strong>free shipping</strong>!";
          } else {
            descHtml = interpolate(CART_T.genericUnlockedHtml || "Congratulations on your <strong>[reward]</strong>.", {
              reward: escapeHtml(m.label.toLowerCase()),
            });
          }
        } else {
          var remaining = m.threshold - bedrag;
          var remainingHtml = "<strong>" + formatMoney(remaining) + "</strong>";
          if (m.type === "shipping" || m.key === "m2") {
            descHtml = interpolate(CART_T.shippingDescRemainingHtml || "Only [amount] away from <strong>free shipping</strong>.", {
              amount: remainingHtml,
            });
          } else {
            descHtml = interpolate(
              CART_T.giftTierRemainingHtml || CART_T.genericRemainingHtml || "Only [amount] away from <strong>[reward]</strong>.",
              { amount: remainingHtml, reward: escapeHtml(m.label) }
            );
          }
        }
        row.innerHTML =
          visualHtml +
          '<div class="cart-gift-item__info">' +
          '<p class="cart-gift-item__name">' + escapeHtml(m.label) + "</p>" +
          '<p class="cart-gift-item__desc">' + descHtml + "</p>" +
          '<span class="cart-gift-badge cart-gift-badge--' + (reached ? "unlocked" : "locked") + '">' +
          (reached ? (CART_T.unlocked || "Unlocked") : (CART_T.locked || "Not yet reached")) +
          "</span>" +
          "</div>";

        panel.appendChild(row);
      });
    },

    // Enrich upsell-cards met compare_at_price (doorgehaalde before-prijs).
    // Nodig omdat Liquid-sync vastzit en upsell-cards in sections/cart-drawer
    // .liquid geen compare_at_price renderen. Fetcht één keer per product-
    // handle de prijs-data, cachet client-side, en injecteert een <s>-element
    // boven de .upsell-card__price.
    _enrichUpsellCompareAtPrices: function () {
      var cards = this.drawer && this.drawer.querySelectorAll(".upsell-card");
      if (!cards || !cards.length) return;

      // Init cache globaal (overleeft refreshes binnen dezelfde pageload)
      if (!window._odureeUpsellProductCache) {
        window._odureeUpsellProductCache = {};
      }
      var cache = window._odureeUpsellProductCache;

      // Parse elke card: haal handle uit product-link (/products/HANDLE?...)
      // + variant-id uit de [data-upsell-add] knop.
      var byHandle = {};
      // Pad naar het product zoals de link het geeft, mét taalmap en vertaalde
      // handle (/de/products/geschenkbox): /products/geschenkbox.js geeft op /de een 404.
      var padVan = {};
      cards.forEach(function (card) {
        if (card.querySelector(".upsell-card__compare")) return; // al verwerkt
        var link = card.querySelector(".upsell-card__img");
        var href = link && link.getAttribute("href");
        if (!href) return;
        var m = href.match(/^([^?#]*?\/products\/([a-z0-9-]+))/i);
        if (!m) return;
        var handle = m[2];
        padVan[handle] = m[1];
        var btn = card.querySelector("[data-upsell-add]");
        var variantId = btn && btn.getAttribute("data-variant-id");
        if (!variantId) return;
        if (!byHandle[handle]) byHandle[handle] = [];
        byHandle[handle].push({ card: card, variantId: String(variantId) });
      });

      // Per unieke handle: fetch eenmaal, vervolgens injecteer compare-prijs
      // voor elke card van die handle.
      Object.keys(byHandle).forEach(function (handle) {
        var entries = byHandle[handle];
        var apply = function (product) {
          if (!product || !product.variants) return;
          var variantMap = {};
          product.variants.forEach(function (v) {
            variantMap[String(v.id)] = v;
          });
          entries.forEach(function (entry) {
            var v = variantMap[entry.variantId];
            if (!v) return;
            var compare = v.compare_at_price;
            var price = v.price;
            if (!compare || compare <= price) return;
            var priceEl = entry.card.querySelector(".upsell-card__price");
            if (!priceEl) return;
            if (entry.card.querySelector(".upsell-card__compare")) return;
            var compareEl = document.createElement("s");
            // Prijstest (Intelligems): de van-prijs volgt de test (odureeIgWas met product- en
            // variant-id); data-ig-orig = het bedrag in de notatie van de pagina, voor
            // assets/oduree-ig-notatie.js. Alles staat erop vóór het element in de pagina komt.
            compareEl.className = "upsell-card__compare odureeIgWas";
            compareEl.setAttribute("data-product-id", String(product.id));
            compareEl.setAttribute("data-variant-id", entry.variantId);
            compareEl.textContent = formatMoney(compare);
            compareEl.setAttribute("data-ig-orig", compareEl.textContent);
            priceEl.parentNode.insertBefore(compareEl, priceEl);
          });
        };

        if (cache[handle]) {
          apply(cache[handle]);
        } else {
          fetch((padVan[handle] || "/products/" + handle) + ".js")
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
              if (p) {
                cache[handle] = p;
                apply(p);
              }
            })
            .catch(function () {});
        }
      });
    },

    // ---------- Section refresh ----------
    // BELANGRIJK: cart-drawer zit in overlay-group.json als group-section.
    // Shopify's `/?sections=cart-drawer` API laadt GEEN section-group-settings,
    // waardoor customizer-instellingen uit overlay-group kunnen ontbreken.
    // Fix: vraag een volledige page op en extract #cart-drawer eruit.
    // Iets langzamer, maar behoudt alle section-group settings correct.
    refresh: function () {
      var self = this;
      // Gelijktijdige aanroepen (cart:refresh én cart:update na een add)
      // delen één ronde; komt er tijdens de ronde nog een aanvraag, dan
      // volgt precies één extra ronde daarna.
      if (self._refreshPromise) {
        self._refreshAgain = true;
        return self._refreshPromise;
      }
      var p = self._refreshRonde().then(function () {
        self._refreshPromise = null;
        if (self._refreshAgain) { self._refreshAgain = false; return self.refresh(); }
      }, function (e) {
        self._refreshPromise = null;
        console.warn("[CartDrawer] refresh error", e);
      });
      self._refreshPromise = p;
      return p;
    },

    _refreshRonde: function () {
      var self = this;
      // Eerst de drempelcadeaus gelijktrekken met de cart (toevoegen boven de
      // drempel, weghalen eronder), dan pas renderen: zo staat het cadeau al
      // in de eerste render en ploft het er niet later bovenop.
      return self._syncGiftTiers().catch(function () { return null; }).then(function () {
        return self._renderVanServer();
      });
    },

    _renderVanServer: function () {
      var self = this;
      // Section Rendering API (alleen de drawer-sectie) met fallback op de
      // volledige pagina. LET OP: het id moet het sectiegroep-id zijn
      // ("sections--<groep>__cart-drawer", uit de wrapper in de DOM); het
      // kale "cart-drawer" rendert met schema-defaults en verliest de
      // instellingen (cadeau-mijlpaal, timer).
      var wrap = self.drawer && self.drawer.closest('.shopify-section, [id^="shopify-section-"]');
      var sectionId = wrap && /^shopify-section-sections--/.test(wrap.id) ? wrap.id.replace(/^shopify-section-/, "") : "";
      var viaSectie = sectionId
        ? fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "?sections=" + encodeURIComponent(sectionId) + "&t=" + Date.now(), {
            headers: { Accept: "application/json" },
            cache: "no-store",
          }).then(function (r) { return r.ok ? r.json() : null; })
        : Promise.resolve(null);
      return viaSectie
        .then(function (json) {
          var html = json && json[sectionId];
          if (html && html.indexOf('id="cart-drawer"') !== -1) return html;
          return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "?cart_refresh=" + Date.now(), { headers: { Accept: "text/html" } })
            .then(function (r) { return r.text(); });
        })
        .then(function (html) {
          if (!html) return;
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");

          // We zoeken in het geparseerde document naar een nieuwe
          // #cart-drawer en vervangen body + footer van onze drawer.
          var newDrawer = doc.getElementById("cart-drawer");
          if (!newDrawer) return;

          // Vangnet: bevat de nieuwe render een drempelcadeau tegen de volle
          // prijs (cart onder de drempel, functie geeft geen korting meer)?
          // Dan deze tussenstand NIET tonen: eerst de cadeauregels
          // synchroniseren en daarna opnieuw renderen (max. 1 herkansing).
          if (newDrawer.querySelector("[data-gift-paid]") && !self._giftPaidRetry) {
            self._giftPaidRetry = true;
            // Volgende ronde synct eerst (zie _refreshRonde) en rendert opnieuw.
            self._refreshAgain = true;
            return;
          }
          self._giftPaidRetry = false;

          // Behoud is-open class maar vervang inner. Regels die nieuw zijn
          // (bijv. het drempelcadeau dat automatisch verschijnt) krijgen een
          // inschuif-animatie in plaats van een harde wissel.
          var wasOpen = self.isOpen();
          var oudeKeys = {};
          self.drawer.querySelectorAll("[data-cart-item][data-key]").forEach(function (el) {
            oudeKeys[el.getAttribute("data-key")] = true;
            var vid = el.getAttribute("data-variant-id");
            if (!vid) return;
            // Variant-sleutel, apart voor cadeauregels (tijdelijke -> echte regel) en gewone regels.
            // Gewone regels: een actie (1+1, Instant Crush, bundel) splitst een regel in een betaald en
            // een gratis deel, en Shopify geeft beide delen een nieuwe key. Zonder deze sleutel klapten
            // ze dicht en schoven ze opnieuw in ("springen eruit en weer erin"); nu alleen een echt
            // nieuw product.
            oudeKeys[(el.hasAttribute("data-cart-gift-item") ? "v:" : "p:") + vid] = true;
          });
          self.drawer.innerHTML = newDrawer.innerHTML;
          if (window.OdureeCartTimer) { try { window.OdureeCartTimer.tik(); } catch (_) {} }
          if (wasOpen) {
            self.drawer.classList.add("is-open");
            self.drawer.querySelectorAll("[data-cart-item][data-key]").forEach(function (el) {
              var vid = el.getAttribute("data-variant-id");
              var bekend = oudeKeys[el.getAttribute("data-key")] || (vid && oudeKeys[(el.hasAttribute("data-cart-gift-item") ? "v:" : "p:") + vid]);
              if (bekend) return;
              el.classList.add("is-new");
              el.addEventListener("animationend", function () { el.classList.remove("is-new"); }, { once: true });
            });
          }

          // Re-assign body ref (het is een nieuwe DOM-node)
          self.body = self.drawer.querySelector("[data-cart-body]");

          // Fix tab-labels (Cadeautje Cadeaus) tot Liquid sync doorkomt.
          self._overrideTabLabels();

          // Overrule reward-bar tekst/progress/ticks en rebuild het
          // Cadeaus-paneel vanuit de dynamische gift tiers.
          self._overrideRewardAndGifts();

          // Doorgestreepte before-prijs op upsell-cards.
          self._enrichUpsellCompareAtPrices();
          // Na elke refresh: sync de dynamische gift tiers.
          self._syncGiftAndMaybeRefresh();

          // Update cart count in navigatie (header-badge)
          var newCountEl = newDrawer.querySelector("[data-cart-count]");
          var newCount = newCountEl
            ? parseInt(newCountEl.textContent.replace(/[^0-9]/g, ""), 10)
            : 0;
          CartDrawer.updateNavBadge(newCount);

          // Broadcast zodat andere UI-componenten (PDP reward-bar, etc.)
          // kunnen meesynchroniseren. Zonder dit blijft bijv. de shipping/gift
          // bar op de productpagina de oude state tonen wanneer klant items
          // via de drawer qty-controls of remove-knop wijzigt.
          document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
        })
        .catch(function (e) {
          console.warn("[CartDrawer] refresh error", e);
        });
    },

    // Update cart-count badges buiten de drawer (header, mobiele knop, etc.)
    updateNavBadge: function (count) {
      document
        .querySelectorAll(
          "[data-cart-count-global], .cart-count, .nav-cart-badge, [data-header-cart-count]",
        )
        .forEach(function (el) {
          if (
            el.classList.contains("nav-cart-badge") ||
            el.hasAttribute("data-header-cart-count")
          ) {
            el.textContent = count;
            el.style.display = count > 0 ? "" : "none";
          } else {
            el.textContent = "(" + count + ")";
          }
        });
    },
  };

  // ---------- ATC interceptor voor formulieren ----------
  // Vangt alle submits op /cart/add forms op, doet AJAX-add en opent de drawer.
  // Oduree eigen PDP + product-card gebruiken al eigen AJAX (en dispatchen
  // cart:refresh) - deze interceptor is voor generieke Shopify-forms.
  document.addEventListener("submit", function (e) {
    var form = e.target.closest(
      'form[action$="/cart/add"], form[action$="/cart/add.js"]',
    );
    if (!form) return;

    // Skip als een andere handler het al overneemt (bijv. oduree-quick-add)
    if (form.hasAttribute("data-oduree-quick-add")) return;
    if (form.hasAttribute("data-atc-form")) return;

    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "...";
    }

    var fd = new FormData(form);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      })
      .then(function () {
        return CartDrawer.refresh();
      })
      .then(function () {
        CartDrawer.open();
        if (btn) {
          btn.textContent = CART_T.addedSuccess || "Added!";
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        }
      })
      .catch(function (err) {
        console.error("[CartDrawer] add error", err);
        if (btn) {
          btn.textContent = originalText;
          btn.disabled = false;
        }
      });
  });

  // ---------- Auto-open trigger via ?open_cart=1 of #cart ----------
  // Bronnen:
  //   * /cart redirect uit layout/theme.liquid /?open_cart=1
  //   * Externe/directe links naar /#cart
  // We verwijderen de marker uit de URL zodat hij niet blijft hangen bij
  // page-reload, back-nav, bookmark of Core Web Vitals tooling.
  function autoOpenFromUrl() {
    var url = new URL(window.location.href);
    var shouldOpen = url.searchParams.get("open_cart") === "1" || url.hash === "#cart";
    if (!shouldOpen) return;

    // Strip marker uit URL (geen reload)
    url.searchParams.delete("open_cart");
    if (url.hash === "#cart") url.hash = "";
    var cleanUrl = url.pathname + (url.search ? url.search : "") + (url.hash || "");
    window.history.replaceState({}, document.title, cleanUrl);

    // Open drawer zodra hij klaar is + refresh zodat cleanup-script z'n werk
    // heeft kunnen doen (verzekerde-verzending verwijderen).
    var openWhenReady = function () {
      if (window.CartDrawer && typeof window.CartDrawer.refresh === "function") {
        window.CartDrawer.refresh().then(function () {
          window.CartDrawer.open();
        });
      } else {
        document.dispatchEvent(new CustomEvent("cart:open"));
      }
    };
    // Kleine delay zodat cleanup in assets/custom.js eerst mag lopen
    setTimeout(openWhenReady, 150);
  }

  // Expose global before init so inline Shopify/theme bridges can still
  // reach the controller if a later init step throws.
  window.CartDrawer = CartDrawer;

  // Init zodra DOM beschikbaar is
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      CartDrawer.init();
      autoOpenFromUrl();
    });
  } else {
    CartDrawer.init();
    autoOpenFromUrl();
  }

})();
